import { Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export const ExportLogsButton = ({ onClick, disabled = false }: Props) => {
  return (
    <Button
      id="kpi-tracker-export-logs-button"
      disabled={disabled}
      variant="outlined"
      size="small"
      startIcon={<LogoutIcon fontSize="small" />}
      onClick={onClick}
    >
      Export Logs
    </Button>
  );
};
